import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useGetVsic from '../../../../../common/category/useGetVsic'
import { UseTypeFontSize } from '../../../../../common/hooks/useTypeFontSize'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { Tooltip } from '../../../../../common/tooltip'
import { selectCompanyInfo } from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { getDefaultVsic } from '../../../../../companyAnalysis/industry/helper'
import { getFontSize } from '../../../../../helpers/fontSize'
import { TYPE_ITEM_SETTING } from '../../../constant'
import { isFs } from '../../../helper'
import { TitlePanelSetting } from '../TitlePanelSetting'
import classes from '../index.module.scss'
import { addPanel, selectCount, selectMainScreen } from '../store/slice'

const FONT_SIZE_ICON = 8
const PADDING_RIGHT_ICON = 10

const PanelItem = ({ item, level }) => {
  const dispatch = useDispatch()
  const typeFontSize = UseTypeFontSize()

  const { children, label, type = '', screen = '', panel = '' } = item

  const count = useSelector(selectCount(`${screen}_${panel}_${type}`))
  const mainScreen = useSelector(selectMainScreen)
  const { vsics } = useGetVsic()
  const companyInfo = useSelector(selectCompanyInfo)

  const [isOpen, setIsOpen] = useState(false)

  const addPanelItem = () => {
    dispatch(
      addPanel({
        ...item,
        mainScreen: type === TYPE_ITEM_SETTING.PANEL ? mainScreen : undefined,
        defaultIndustryId:
          item.screen === 'industryAnalysis'
            ? getDefaultVsic(vsics, companyInfo.mainVsicId).id
            : undefined,
      }),
    )
  }

  const isFirstLevel = level === 1

  const collapse = () => setIsOpen(!isOpen)

  const isDisable = isFs(screen) && count

  return (
    <>
      <div style={{ paddingLeft: (level - 1) * 20 }} className={classes.item}>
        <div
          onClick={children ? collapse : undefined}
          className={`w100 ${classes.name} ${isFirstLevel ? 'fw600' : ''} ${
            children ? 'cursorPointer' : ''
          }`}
        >
          {children && (
            <Icon
              className={isOpen ? 'icon-caret-bottom' : 'icon-caret-right'}
              style={{
                fontSize: FONT_SIZE_ICON,
                paddingRight: !isOpen
                  ? getFontSize(4, typeFontSize) + PADDING_RIGHT_ICON
                  : PADDING_RIGHT_ICON,
              }}
            />
          )}
          <Element
            className="w100"
            style={{
              color: count ? '#0553A5' : undefined,
              paddingLeft:
                !children && isFirstLevel
                  ? getFontSize(FONT_SIZE_ICON, typeFontSize) +
                    PADDING_RIGHT_ICON
                  : 0,
            }}
          >
            <TitlePanelSetting label={label} />
            {type === TYPE_ITEM_SETTING.CHAPTER_HEADER && (
              <Tooltip
                elementName="span"
                tooltipContent="dynamicReport.TOOLTIP_CHAPPER_HEADER"
                isI18n
              >
                <Icon
                  className="icon-info-circle pl1"
                  style={{ color: '#9C9C9C' }}
                />
              </Tooltip>
            )}
          </Element>
        </div>
        {type && (
          <div className="dFlex alignItemsCenter">
            <span className={classes.count}>({count || 0})</span>
            <Icon
              onClick={!isDisable ? addPanelItem : undefined}
              style={{
                color: '#2C73E8',
                fontSize: 16,
                opacity: isDisable ? 0.4 : 1,
              }}
              className="icon-plus-circle-fill"
            />
          </div>
        )}
      </div>
      {children &&
        isOpen &&
        children.map((panel, index) => {
          return <PanelItem key={index} item={panel} level={level + 1} />
        })}
    </>
  )
}

export default PanelItem
